import { Box, Stack, Typography } from "@mui/material";
import { ApplicantComment } from "Components/Applicants/ApplicantsList/ApplicantComment";
import { useAppSelector } from "helpers/hooks";
import moment from "moment";
import { UnderlinedText } from "shared/SharedStyles/ShDataDisplay";

export const ApplicantComments = () => {

    const { currentApplicantProfile, applicantSummary } = useAppSelector((state) => state.employer.applicantsList);

    return (<>
        <Stack rowGap={2}>
            {applicantSummary?.commentSummaries?.map(comment => (
                <Stack key={comment.commentId} justifyContent='center'>
                    <UnderlinedText variant='subtitle2' fontWeight='bold'
                        gutterBottom width='fit-content'>Comments</UnderlinedText>
                    <Stack flexDirection='row' alignItems='center' columnGap={1} marginBottom={0.5}>
                        <Typography variant='body2' whiteSpace='nowrap'>Commented by :</Typography>
                        <Typography variant='body2' fontWeight='bold'>{comment.commentOwner}</Typography>
                    </Stack>
                    <Stack flexDirection='row' alignItems='center' columnGap={1} marginBottom={0.5}>
                        <Typography variant='body2' whiteSpace='nowrap'>Comment :</Typography>
                        <Typography variant='body2'>{comment.comment}</Typography>
                    </Stack>
                    <Stack flexDirection='row' alignItems='center' columnGap={1} marginBottom={0.5}>
                        <Typography variant='body2' whiteSpace='nowrap'>Commented on:</Typography>
                        <Typography variant='body2'>{moment(comment.commentDate).format("MMM DD, YYYY")}</Typography>
                    </Stack>
                </Stack>
            ))}
            {currentApplicantProfile &&
                <Box width='fit-content'>
                    <ApplicantComment applicantId={currentApplicantProfile?.candidateEmployerJobId} label="Edit Comment" />
                </Box>
            }
        </Stack>
    </>);
};